import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.replace('/portfolio.html');
  }, []);
  return null;
}

export default App;
